<template>
  <!-- HST機器受領 -->
  <div id="HSTDeviceReturn">
    <div id="container">
      <hstNavi v-bind:pageid='"HSTDeviceReturn"'></hstNavi>
      <div class="labelTitle lable">睡眠検査機器配送ｻｰﾋﾞｽ 機器受領</div>
      <div class="condition-area">
        <table class="conditionTable">
          <tr>
            <th>シリアル番号</th>
            <td><input type="text" id="serialInput" v-model="serial" @keyup.enter="onKeyupEnter()"/></td>
          </tr>
        </table>
          <b-button class="addButton is-primary" @click="addDevice">追加</b-button>
      </div>
      <div class="result-area" v-if="data.length > 0">
        <div class="button-area">
          <b-button class="clipboadCopyButton is-primary" @click="clipboardCopy('deviceReceiptListTableCopy')">クリップボードにコピー</b-button>
          <span class="result-count">件数：{{data.length}}件</span>
        </div>
        <b-table
            id="deviceReceiptListTable"
            :data="data"
            default-sort="user.first_name"
            aria-next-label="Next page"
            aria-previous-label="Previous page"
            aria-page-label="Page"
            aria-current-label="Current page">
            <template slot-scope="props">
              <b-table-column label="#" width="40" centered>{{props.index + 1}}</b-table-column>
              <b-table-column field="serial" label="シリアル番号" width="130" centered >
                {{props.row.serial}}
              </b-table-column>
              <b-table-column field="leaseUpDate" label="リースアップ日" width="110" centered >
                {{props.row.leaseUpDate}}
              </b-table-column>
              <b-table-column field="instrumentKind" label="機種" width="140">
                {{props.row.instrumentKind}}
              </b-table-column>
              <b-table-column field="snoreSensor" label="いびきセンサー同梱の有無" width="120" sortable >
                {{props.row.snoreSensor | snoreSensorFilter() }}
              </b-table-column>
              <b-table-column field="id" label="受付番号" width="130" centered>
                <a @click="showDetail(props.row.applicationDetails)">{{props.row.receiptNumber}} <b-icon icon="vector-arrange-above" /></a>
              </b-table-column>
              <b-table-column field="shippingDate" label="出荷日" width="100">
                {{props.row.shippingDate}}
              </b-table-column>
              <b-table-column field="client" label="依頼元">
                {{props.row.client}}
              </b-table-column>
              <b-table-column field="hospital" label="医療機関">
                {{props.row.hospital}}
              </b-table-column>
              <b-table-column field="patientName" label="患者名" width="130">
                {{props.row.patientName}}
              </b-table-column>
              <!-- 20230530 川越#161追加 -->
              <b-table-column field="receptionNote" label="受付備考" width="150" >
                {{props.row.receptionNote}}
              </b-table-column>
              <b-table-column field="delete" label="取り消し" width="70" centered >
                <b-button class="clearButton" @click="clearDevice(props.index)" icon-left="eraser"></b-button>
              </b-table-column>
            </template>
        </b-table>
        <div class="forClipboadCopy">
        <b-table
          id="deviceReceiptListTableCopy"
          :data="data">
            <template slot-scope="props">
              <b-table-column field="serial" label="シリアル番号" width="130" centered >{{props.row.serial}}</b-table-column>
              <b-table-column field="shippingDate" label="出荷日" width="100">{{props.row.shippingDate}}</b-table-column>
              <b-table-column field="today" label="返却日">{{today}}</b-table-column>
            </template>
        </b-table>
        </div>
        <div class="button-area">
          <b-button class="receptionistButton is-primary"  :disabled="!data.length" @click="deviceReceipt">機器受領</b-button>
        </div>        
      </div>
    </div>
    <floatingModal name="detail-modal" modalClass="detail-modal" @close="closeDetail" title="" width="640" height="480" top="100px" right="100px">
      <hstRequestDetail :data="showDetailTargetData" />
    </floatingModal>
  </div>
</template>

<script>
import floatingModal from "@/components/mock/common/FloatingModal";
import HSTRequestDetail from "@/components/mock/common/HSTRequestDetail";
import naviBar from "@/components/mock/philips/hst/HSTNaviBar";

export default {
  name: "HSTDeviceReturn",
  methods: {
    onKeyupEnter: function(){
      if(this.serial){
        //シリアルを取得
        let serialItems = this.serial.split('/');
        if(serialItems.length == 2){
          //　"/"が含まれていたらそれ以降の文字に変更する
          this.serial = serialItems[1]
        }
        this.addDevice();
      }
      else {
        this.addDevice();
      }
    },
    onFocus: function(){
      document.getElementById("serialInput").focus()
    },
    addDevice: async function(){
      if(!this.serial){
          var messsge ="シリアル番号を入力してください。";
          this.$dialog.alert({
            title: '　',
            message: messsge,
          })
      } else {
         var targetSerial = this.data.find(val => val.serial == this.serial)
        if(targetSerial){
          var messsge ="シリアル番号:"+this.serial+" は既に機器受領リストに追加済みです。";
          this.$dialog.alert({
            title: '　',
            message: messsge,
          })
          return
        }
        var excuteApi = this.getHstReturnDevicePOST;
        var successCallBack = this.getHstReturnDevicePOSTSuccess;
        var errorCallBack = this.getHstReturnDevicePOSTError;
        // WebAPI Call
        await this.apiCall(excuteApi, successCallBack, errorCallBack);
      }
    },
    getHstReturnDevicePOST: function(client) {
      return client.apis.internalHst.getHstReturnDevicePOST({ 
        body: {
          serial:this.serial
        } 
      });
    },
    getHstReturnDevicePOSTSuccess: function(result) {
      var machineDetail = result.obj;
      console.log(machineDetail)
      this.data.push(machineDetail);
      if(this.isPastday(machineDetail.leaseUpDate)){
        // リースアップ日を超えている場合は、警告メッセージ
        var messsge = machineDetail.leaseUpDate + "にリースアップ日を超過している機器です。";
          this.$dialog.alert({
            title: '　',
            message: messsge
          })
      }else{
        if(this.isSoon(machineDetail.leaseUpDate,2)){
          // リースアップ日が2ヶ月以内の場合近づいている場合は、警告メッセージ
          var messsge = machineDetail.leaseUpDate + "にリースアップする機器です。";
          this.$dialog.alert({
            title: '　',
            message: messsge
          })
        }
      }

      this.$nextTick(() => {
        //DOMが更新された後に呼ばれるコールバック
        var element = document.getElementById("deviceReceiptListTable")
        if(element){
          var scrollElement= element.getElementsByClassName("table-wrapper")[0]
          scrollElement.scrollTop = scrollElement.scrollHeight;  //スクロールバーを一番下に移動する
      }
      })
      this.serial = ""
      this.onFocus();
    },
    getHstReturnDevicePOSTError: function(result) {
      // シリアルに一致する利用可能な機器が存在しない場合
      this.serial = ""
      this.showErrorMessage(result,this.onFocus());
    },
    clearDevice: function(index) {
      this.data.splice(index, 1);
    },
    deviceReceipt: function(){
      var excuteApi = this.setHstDeviceReceiptPOST;
      var successCallBack = this.setHstDeviceReceiptPOSTSuccess;
      var errorCallBack = this.setHstDeviceReceiptPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    setHstDeviceReceiptPOST: function(client) {
      var obj = []
      for(var i=0; i < this.data.length; i++){
        obj.push({
          receiptNumber:this.data[i].receiptNumber
        })
      }
      return client.apis.internalHst.setHstDeviceReceiptPOST({
        body: obj
      });
    },
    setHstDeviceReceiptPOSTSuccess: function(result) {
      // 検索結果取得
      this.data = []
      this.showSuccess(result);
    },
    setHstDeviceReceiptPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    showDetail: function(rowData) {
      this.showDetailTargetData = rowData
      this.$modal.show('detail-modal')
    },
    closeDetail: function(){
      this.$modal.hide('detail-modal')
    },
    clipboardCopy: function(elementId) {
      console.log(elementId);
      var btable = document.getElementById(elementId);
      var tbody = btable.getElementsByTagName("tbody")[0];
      navigator.clipboard.writeText(tbody.innerText).then(() => {
          this.showMessage("クリップボードにコピーしました。");
        }).catch(err => {
          this.showMessage("コピーに失敗しました");
          console.log(err);
        });
    }
  },
  data() {
    return {
      data : [],
      isPaginated : true,
      serial:null,
      showDetailTargetData:{},
      today:this.yyyy_sla_MM_sla_dd(new Date())
    };
  },
  filters: {
    snoreSensorFilter: function(value){
      if (value == "1") {
        return "無"
      } else if (value == "2") {
        return "有"
      } else {
        return "-"
      }
    },
  },
  components: {
    hstNavi: naviBar,
    floatingModal:floatingModal,
    hstRequestDetail:HSTRequestDetail
  },
};
</script>
<style lang="scss" scoped>
.condition-area {
    display: flex;
}
.conditionTable {
  width: 400px;
}
.addButton {
    margin-left:20px;
}
.dataExtractButton {
    margin-left: auto;
    margin-right: 10px;
}
.result-area {
  margin-top: 20px;
}
a {
  text-decoration: underline;
}
.opration-area {
    height:50px;
    margin-bottom: 10px;
}
.forClipboadCopy {
  display: block;
  position:absolute;
  top: -99999px;
  left: -99999px;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/philips/hst/HSTDeviceReturn.vue